export function getTotalDisplays(cart){
  return cart.reduce((acc, display) => {
      let count = 0
      // is circuit
      if (display.count_secondary_displays) {
        // if has multiple faces, count the number of faces else count 1
        count = display.secondary_displays.reduce((acc, secondaryDisplay) => {
          return acc + (secondaryDisplay.mirror_screens_count > 1 ? secondaryDisplay.mirror_screens_count : 1)
        }, 0)
      }
      // if is not circuit, check if has multiple faces
      if (display.count_secondary_displays === 0 && display.mirror_screens_count > 1) {
        count = display.mirror_screens_count
      }
      // if is not circuit and has no multiple faces, count 1
      if (display.count_secondary_displays === 0 && display.mirror_screens_count === 1) {
        count = 1
      }
      return acc + count
  }, 0)
}

export function getTotalCircuitsDisplays(cart){
    return cart.reduce((acc, display) => acc + (display.count_secondary_displays || 0), 0)
}

export function getTotalCircuits(cart){
    return cart.reduce((acc, display) => acc + (display.count_secondary_displays >= 1 ? 1 : 0), 0)
}

export function getTotalDisplaysWithMultipleFacesInCircuits(cart) {
    return cart.reduce((acc, display) => {
        if (display.count_secondary_displays) {
            return acc + display.secondary_displays.reduce((acc, secondaryDisplay) => acc + (secondaryDisplay.mirror_screens_count > 1 ? 1 : 0), 0)
        }
        return acc
    }, 0)
}

export function getTotalMultipleFacesInCircuits(cart){
    return cart.reduce((acc, display) => {
        if (display.count_secondary_displays) {
            return acc + display.secondary_displays.reduce((acc, secondaryDisplay) => acc + (secondaryDisplay.mirror_screens_count > 1 ? secondaryDisplay.mirror_screens_count : 0), 0)
        }
        return acc
    }, 0)
}

export function getTotalIndividualDisplays(cart){
    return cart.reduce((acc, display) => acc + (display.count_secondary_displays >= 1 || display.mirror_screens_count > 1 ? 0 : 1), 0)
}

export function getTotalMultipleFacesDisplays(cart){
    return cart.reduce((acc, display) => {
        // If it's a circuit (has count_secondary_displays), don't count this display
        // because priority is circuit > multiple faces
        if (display.count_secondary_displays) {
            return acc
        }
        // Only count displays with multiple faces if it's NOT a circuit
        return acc + (display.mirror_screens_count > 1 ? 1 : 0)
    }, 0)
}

export function getTotalMultipleFaces(cart){
    return cart.reduce((acc, display) => {
        // If it's a circuit (has count_secondary_displays), don't count mirror_screens_count
        // because priority is circuit > multiple faces
        if (display.count_secondary_displays) {
            return acc
        }
        // Only count mirror_screens_count if it's NOT a circuit
        return acc + (display.mirror_screens_count > 1 ? display.mirror_screens_count : 0)
    }, 0)
}